export default (theme) => ({
  container: {
    maxWidth: 1200,
    margin: "auto",
  },
  item: {
    minWidth: 300,
  },
  paper: {
    padding: 16,
    cursor: "pointer",
    borderTop: "solid 4px #ff9800",
  },
});
